export default function StatusBadge({ status }) {
    if (status === "completed") {
        return (
            <span className="status-badge status-completed">
                <span className="status-badge-icon"><img src="circular-complete.svg" /></span> Completed
            </span>
        );
    }
    return (
        <span className="status-badge status-cancelled">
            <span className="status-badge-icon"><img src="circular-cancelled.svg" /></span> Cancelled
        </span>
    );
}
